import { defineComponent as _defineComponent } from 'vue'
import { createTextVNode as _createTextVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, renderList as _renderList, createVNode as _createVNode, unref as _unref, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-c2f79986"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "family-group-list" }
const _hoisted_2 = { class: "help-text" }
const _hoisted_3 = {
  key: 0,
  class: "invite-area"
}
const _hoisted_4 = { class: "header-text" }
const _hoisted_5 = { class: "badge notify-badge rounded-pill" }
const _hoisted_6 = { class: "list-unstyled invite-list" }
const _hoisted_7 = {
  key: 0,
  class: "empty-list"
}
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h4", { class: "mt-3" }, "Member of", -1))
const _hoisted_9 = {
  key: 1,
  class: "list-unstyled group-list"
}
const _hoisted_10 = {
  key: 2,
  class: "empty-list"
}
const _hoisted_11 = { class: "actions-row" }

import { computed, ref } from 'vue'
import { useRouter } from 'vue-router'
import { FamilyGroup, InvitationResult, PrincipalType } from '@/gp/GroupAdminModel'
import { useFamilyGroupStore } from '@/gp/FamilyGroupStore'
import { useFamilyGroupMemberStore } from '@/gp/FamilyGroupMemberStore'
import { useFamilyGroupInviteStore } from '@/gp/FamilyGroupInviteStore'
import { useDataGroupMemberStore } from '@/gp/DataGroupMemberStore'
import { useUserStore } from '@/gp/UserStore'
import { LoadMode } from '@/util/AsyncData'
import { PlusIcon } from '@zhuowenli/vue-feather-icons'
import { useTokenManager } from '@/auth/TokenManager'
import { sortBy, uniq } from 'lodash'
import FamilyGroupInviteItem from './FamilyGroupInviteItem.vue'
import FamilyGroupItem from './FamilyGroupItem.vue'
import FamilyGroupInviteModal from './FamilyGroupInviteModal.vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'FamilyGroupList',
  props: {
    userId: {},
    forUserProfile: { type: Boolean }
  },
  setup(__props: any) {

const props = __props;



const inviteModalRef = ref<InstanceType<typeof FamilyGroupInviteModal>>()

const userStore = useUserStore()
const familyGroupStore = useFamilyGroupStore()
const inviteStore = useFamilyGroupInviteStore()
const memberStore = useFamilyGroupMemberStore()
const dataGroupMemberStore = useDataGroupMemberStore()
const tokenManager = useTokenManager()
const router = useRouter()

const userIdRef = computed(() => props.userId ?? tokenManager.current.userId)
const userRef = computed(() => userStore.getAsyncUser(userIdRef.value, LoadMode.EnsureLoaded)?.data)
const isSelfRef = computed(() => userIdRef.value == tokenManager.current.userId)
const pendingInvitesRef = computed(() => inviteStore.getInvitesForUser(userIdRef.value, LoadMode.EnsureLoaded)
  .filter(inv => inv.result == InvitationResult.Pending))
const familyGroupsRef = computed(() => {
  const fms = memberStore.getMembersForUsers([userIdRef.value], LoadMode.EnsureLoaded)
  const dms = dataGroupMemberStore.getMembersForDataGroups([userRef.value?.profileDataGroupId], LoadMode.EnsureLoaded)
    .filter(dm => dm.principalType == PrincipalType.FamilyGroup)
  const familyGroupIds = uniq([...fms.map(fm => fm.familyGroupId), ...dms.map(dm => dm.principalId)])
  const familyGroups = familyGroupStore.getGroupList(familyGroupIds) // loaded inline
  sortBy(familyGroups, fg => fg.name)
  return familyGroups;
})

const canAddGroupRef = computed(() => !props.forUserProfile && isSelfRef.value && !tokenManager.current.isSupervised)

async function showInvite(inviteId: string) {
  inviteModalRef.value?.openEdit(inviteId)
}

async function createGroup() {
  if (userRef.value) {
    const fg = new FamilyGroup()
    fg.name = FamilyGroup.getDefaultName(userRef.value)
    const fgId = await familyGroupStore.addAsync(fg)
    router.push(FamilyGroup.getPageUrl(fgId))
  }
}

function onJoinGroup() {
  alert("join!")
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("p", _hoisted_2, [
      (props.forUserProfile)
        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
            _createTextVNode("These are the groups this user belongs to that are also visible to you.")
          ], 64))
        : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
            _createTextVNode("Use groups to share trees and explore them with other family members.")
          ], 64))
    ]),
    (pendingInvitesRef.value.length > 0)
      ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
          _createElementVNode("h4", null, [
            _createElementVNode("span", _hoisted_4, [
              _createTextVNode(" Invitations "),
              _createElementVNode("span", _hoisted_5, _toDisplayString(pendingInvitesRef.value.length), 1)
            ])
          ]),
          _createElementVNode("ul", _hoisted_6, [
            (pendingInvitesRef.value.length == 0)
              ? (_openBlock(), _createElementBlock("li", _hoisted_7, " None "))
              : _createCommentVNode("", true),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(pendingInvitesRef.value, (inv) => {
              return (_openBlock(), _createElementBlock("li", {
                key: inv.id
              }, [
                _createVNode(FamilyGroupInviteItem, {
                  inviteId: inv.id,
                  "select-mode": "",
                  onClick: showInvite
                }, null, 8, ["inviteId"])
              ]))
            }), 128))
          ]),
          _hoisted_8
        ]))
      : _createCommentVNode("", true),
    (familyGroupsRef.value.length)
      ? (_openBlock(), _createElementBlock("ul", _hoisted_9, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(familyGroupsRef.value, (fg) => {
            return (_openBlock(), _createElementBlock("li", {
              key: fg.id
            }, [
              _createVNode(FamilyGroupItem, {
                "family-group-id": fg.id,
                "user-id": userIdRef.value
              }, null, 8, ["family-group-id", "user-id"])
            ]))
          }), 128))
        ]))
      : (_openBlock(), _createElementBlock("div", _hoisted_10, [
          (isSelfRef.value)
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                _createTextVNode("You are not a member of any groups.")
              ], 64))
            : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                _createTextVNode("This user is not a member of any groups.")
              ], 64))
        ])),
    _createElementVNode("div", _hoisted_11, [
      (canAddGroupRef.value)
        ? (_openBlock(), _createElementBlock("button", {
            key: 0,
            type: "button",
            class: _normalizeClass(["btn btn-primary", { ['btn-sm']: familyGroupsRef.value.length }]),
            onClick: createGroup
          }, [
            _createVNode(_unref(PlusIcon), {
              size: "1.2x",
              class: "mb-1"
            }),
            _createTextVNode(" Create a group ")
          ], 2))
        : _createCommentVNode("", true)
    ]),
    _createVNode(FamilyGroupInviteModal, {
      ref_key: "inviteModalRef",
      ref: inviteModalRef
    }, null, 512)
  ]))
}
}

})